import type { DaySchedule, NextPrayerInfo } from "./types";

export function findNextPrayer(today: DaySchedule, tomorrow: DaySchedule, now: Date): NextPrayerInfo {
  for (const p of today.prayers) {
    if (now < p.azaanTime) {
      return { prayer: p, secondsUntil: secondsBetween(now, p.azaanTime), isNextDay: false };
    }
  }
  const fajrTomorrow = tomorrow.prayers[0];
  if (!fajrTomorrow) {
    throw new Error("Tomorrow schedule must include Fajr");
  }
  return {
    prayer: fajrTomorrow,
    secondsUntil: secondsBetween(now, fajrTomorrow.azaanTime),
    isNextDay: true,
  };
}

function secondsBetween(a: Date, b: Date): number {
  const s = Math.floor((b.getTime() - a.getTime()) / 1000);
  return s > 0 ? s : 0;
}

export function formatCountdown(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => n.toString().padStart(2, "0");
  if (h > 0) return `${h}h ${pad(m)}m ${pad(sec)}s`;
  return `${pad(m)}m ${pad(sec)}s`;
}
